module.exports = global.config = {
    i18n: {
        welcome: {
            en: "Welcome",
            fa: "خوش آمدید"
        }
        // rest of your translation object
    },
    // other global config variables you wish
    nav: {
        url: "/", //http://localhost:3020/
        full_url: "https://apafrep.web.app",
        email: "ndamhamidou@gmail.com"
    }
};